import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';
import { BenefitsByMonth } from 'src/app/shared/models/benefits.models';

@Component({
  selector: 'app-calendar-pay-month',
  templateUrl: './calendar-pay-month.component.html',
  styleUrls: ['./calendar-pay-month.component.scss'],
})
export class CalendarPayMonthComponent implements OnInit {

  @Input() monthWithBenefits: BenefitsByMonth;
  @Input() indice: number;

  constructor(private utils: UtilsService) { }

  ngOnInit() {
    for (let i = 0; i < this.monthWithBenefits.benefits.length; i++) {
      this.monthWithBenefits.benefits[i]['month'] = this.utils.parseMonthShort(this.monthWithBenefits.date[1]);
      this.monthWithBenefits.benefits[i]['day'] = this.monthWithBenefits.benefits[i]['date'][2];
      this.monthWithBenefits.benefits[i]['fullDate'] = `${this.monthWithBenefits.benefits[i]['date'][2]}/${this.monthWithBenefits.benefits[i]['date'][1]}/${this.monthWithBenefits.benefits[i]['date'][0]}`;
    }

    if (this.monthWithBenefits.benefits) {
      this.monthWithBenefits.benefits.sort((a, b) => {
        const dateA = new Date(a.date![0], a.date![1] - 1, a.date![2]);
        const dateB = new Date(b.date![0], b.date![1] - 1, b.date![2]);
        return dateA.getTime() - dateB.getTime();
      });
    }
  }
}
